import { createContext } from "preact";
import { useContext } from "preact/hooks";

// The message the server's loader drew on this mount (live_island_page), which `live-island` provides, so a
// page-sized loader repeats it instead of changing its words mid-load.
export const LoadingMessage = createContext<string | undefined>(undefined);

// A live view waiting for its data, centred in its own area; the server draws the same markup (live_sheets/_loading).
// `busy` off leaves the words alone, for a view that has stopped trying (offline, no access).
export function Loading({ label, busy = true, compact = false }: { label: string; busy?: boolean; compact?: boolean }) {
	const message = useContext(LoadingMessage);
	return (
		<div class={compact ? "odo-loading odo-loading--compact" : "odo-loading"} role="status">
			{busy && <span class="odo-loading__die" aria-hidden="true" />}
			<p class="odo-loading__text">{busy && !compact ? (message ?? label) : label}</p>
		</div>
	);
}
